import React from "react";
import { Link } from "react-router-dom";
import { Search, ShoppingBag, Menu, X } from "lucide-react";
import logo from "../assets/logo.png";
import { useCart } from "../context/CartContext";

export default function Nav({
  scrolled,
  menuOpen,
  setMenuOpen,
  solid,
}) {
  const { cartCount, bump } = useCart();

  const isSolid = scrolled || solid;

  return (
    <div className="fixed top-4 left-0 right-0 z-50 flex justify-center px-4">
      <nav
        className={`w-full max-w-7xl transition-all duration-500 rounded-full ${
          isSolid
            ? "py-1"
            : "py-1"
        }`}
        style={{
          background: "rgba(15,15,18,0.72)",
          backdropFilter: "blur(18px)",
          WebkitBackdropFilter: "blur(18px)",
          border: "1px solid rgba(255,255,255,.08)",
          boxShadow:
            "0 10px 35px rgba(0,0,0,.45), inset 0 1px rgba(255,255,255,.05)",
        }}
      >
        <div className="px-8 flex items-center justify-between">

          {/* Logo */}

          <Link
            to="/"
            className="flex items-center gap-3 group"
          >
            <img
              src={logo}
              alt="logo"
              className="h-14 transition duration-300 group-hover:scale-110"
            />

            <span
              className="text-white text-2xl font-semibold tracking-wide"
              style={{ fontFamily: "Fraunces, serif" }}
            >
              BBS
              <span className="text-[#1E9AFF]">.</span>
            </span>
          </Link>

          {/* Desktop Menu */}

          <div className="hidden md:flex items-center gap-10 text-sm uppercase tracking-[3px]">

            {[
              {
                title: "Shop",
                link: "/#shop",
              },
              {
                title: "Collections",
                link: "/#categories",
              },
              {
                title: "About",
                link: "/#about",
              },
              {
                title: "Journal",
                link: "/#journal",
              },
            ].map((item) => (
              <Link
                key={item.title}
                to={item.link}
                className="relative text-white/75 hover:text-white transition duration-300 after:absolute after:left-0 after:-bottom-2 after:h-[2px] after:w-0 after:bg-[#1E9AFF] after:transition-all after:duration-300 hover:after:w-full"
              >
                {item.title}
              </Link>
            ))}
          </div>

          {/* Icons */}

          <div className="flex items-center gap-5">

            <button className="text-white/80 hover:text-[#1E9AFF] transition">
              <Search
                size={19}
                strokeWidth={2}
              />
            </button>

            <Link
              to="/cart"
              className="relative text-white/80 hover:text-[#1E9AFF] transition"
            >
              <ShoppingBag
                size={19}
                className={bump ? "cart-bump" : ""}
              />

              {cartCount > 0 && (
                <span
                  className="absolute -top-2 -right-2 rounded-full flex items-center justify-center text-[10px] font-semibold"
                  style={{
                    width: 18,
                    height: 18,
                    background: "#1E9AFF",
                    color: "#fff",
                    boxShadow:
                      "0 0 12px rgba(30,154,255,.8)",
                  }}
                >
                  {cartCount}
                </span>
              )}
            </Link>

            <button
              className="md:hidden text-white"
              onClick={() =>
                setMenuOpen(!menuOpen)
              }
            >
              {menuOpen ? (
                <X size={24} />
              ) : (
                <Menu size={24} />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}

        <div
          className={`md:hidden overflow-hidden transition-all duration-500 ${
            menuOpen
              ? "max-h-96 opacity-100 mt-5"
              : "max-h-0 opacity-0"
          }`}
        >
          <div className="mx-5 mb-5 rounded-3xl bg-[#111827]/95 backdrop-blur-xl border border-white/10 shadow-2xl p-6 flex flex-col gap-5 text-center uppercase tracking-[2px]">

            <Link
              to="/#shop"
              onClick={() =>
                setMenuOpen(false)
              }
              className="text-white/80 hover:text-[#1E9AFF]"
            >
              Shop
            </Link>

            <Link
              to="/#categories"
              onClick={() =>
                setMenuOpen(false)
              }
              className="text-white/80 hover:text-[#1E9AFF]"
            >
              Collections
            </Link>

            <Link
              to="/#about"
              onClick={() =>
                setMenuOpen(false)
              }
              className="text-white/80 hover:text-[#1E9AFF]"
            >
              About
            </Link>

            <Link
              to="/#journal"
              onClick={() =>
                setMenuOpen(false)
              }
              className="text-white/80 hover:text-[#1E9AFF]"
            >
              Journal
            </Link>
          </div>
        </div>
      </nav>
    </div>
  );
}